declare const $: any;
export class store_carousel_carousel_controller {
    options: any;
    constructor(private $timeout) {
        "ngInject"
    }

    $onInit() {
        this.$timeout(() => {

            $(`#ecb_carousel${this.options.id}`).owlCarousel({
                loop: true,
                margin: 10,
                responsiveClass: true,
                rtl:true,
                responsive: {
                    0: {
                        items: 1,
                        nav: true
                    },
                    600: {
                        items: 3,
                        nav: false
                    },
                    1000: {
                        items: 5,
                        nav: true,
                        loop: false
                    }
                }
            })

        }, 1000)
    }
}


// WEBPACK FOOTER //
// ./src/components/store-carousel-carousel/store-carousel-carousel.controller.ts